<section class="w-full h-full bg-[#FAFAFA] md:px-10 md:py-16 px-4 py-8">
  <div class="container mx-auto h-full w-full">
    <div class="flex flex-col justify-evenly gap-14 md:gap-0 items-center h-full w-full">
      <div class="flex flex-col lg:flex-row justify-between items-center gap-4 w-full md:mt-14">
        <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8 md:mb-0 mb-5">
          <div class="w-full h-full">
            <img
              src="lite/flow_tournament/flow_tour1.png"
              alt="Lite Flow Tournament 1"
              class="w-full h-full object-cover"
            />
          </div>
          <div class="flex items-center justify-center gap-2">
            <p
              i18n="lite.flow.tournament|Player Join Tournament step@@lite.flow.tournament.step1"
              class="text-black md:text-base text-smfont-medium"
            >
              Player Join Tournament
            </p>
          </div>
        </div>

        <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8 md:mb-0 mb-5">
          <div class="w-full h-full">
            <img
              src="lite/flow_tournament/flow_tour2.png"
              alt="Lite Flow Tournament 2"
              class="w-full h-full object-cover"
            />
          </div>
          <div class="flex items-center justify-center gap-2">
            <p
              i18n="lite.flow.tournament|Get Team step@@lite.flow.tournament.step2"
              class="text-black md:text-base text-sm font-medium"
            >
              Get Team
            </p>
          </div>
        </div>

        <div class="max-w-60 flex flex-col items-center justify-center gap-4 md:gap-8">
          <div class="w-full h-full">
            <img
              src="lite/flow_tournament/flow_tour3.png"
              alt="Lite Flow Tournament 3"
              class="w-full h-full object-cover"
            />
          </div>
          <div class="flex items-center justify-center gap-2">
            <p
              i18n="lite.flow.tournament|View & Share Result step@@lite.flow.tournament.step3"
              class="text-black md:text-base text-sm font-medium"
            >
              View & Share Result
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
